import { render } from "./CreditUtilizationRatioChart.vue?vue&type=template&id=50d6b0fd&ts=true"
import script from "./CreditUtilizationRatioChart.vue?vue&type=script&lang=ts"
export * from "./CreditUtilizationRatioChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__